// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3UkJa","inner":"Footer_inner__3_JRS"};